import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import { DBNEntityAttributesContainers } from '../function-and-entity-attributes/containers/entity-attributes.containers';
import DBNCategoryBasicInfoComponent from './dbn-category-basic-info.component';
import DBNCategoryAccountMappings from './dbn-category-account-mappings';
import DBNCategoryProductMappings from './dbn-category-product-mappings';

function DBNCategoryComponent({
    handleInnerFormChange, 
    selectedDbnDomain, 
    selectedDbnCategory, 
    domains, 
    categories, 
    back, 
    handleFormSubmit,
    openNetworkEntityAttributes,
    setOpenNetworkEntityAttributes,
    id,
    mappedOwnerType,
    openNetworkSubDomains,
    openNetworkCategories
}: any) {

    const tabItems = [
        {
            id: 0,
            title: 'DBN Category',
            component: <DBNCategoryBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectedDbnDomain={selectedDbnDomain}
                selectedDbnCategory={selectedDbnCategory}
                domains={domains}
                categories={categories}
            />,
            isVisible: true,
        },
        {
            id: 1,
            title: 'Account Mappings',
            component: <DBNCategoryAccountMappings
                id={id}
            />,
            isVisible: true,
        },
        {
            id: 2,
            title: `OpenNetwork Entity Attributes`,
            component: (
                <DBNEntityAttributesContainers
                    ownerTypeId={3}
                    id={id}
                    category={selectedDbnCategory}
                    openNetworkEntityAttributes={openNetworkEntityAttributes}
                    setOpenNetworkEntityAttributes={setOpenNetworkEntityAttributes}
                    mappenOwnerType={mappedOwnerType}
                    openNetworkSubDomains={openNetworkSubDomains}
                    openNetworkCategories={openNetworkCategories}
                />
            ),
            isVisible: false,
        },   
        {  
            id: 3,
            title: 'Mapped Products',
            component: <DBNCategoryProductMappings
                category={selectedDbnCategory}
            />,
            isVisible: id > 0,
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">

            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                {/* <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button> */}
            </div>
        </div>
    );
}

export default DBNCategoryComponent;
